import { z } from 'zod';

export const partnerSchema = z.object({
  role: z.enum(['pharmacy', 'doctor', 'clinic', 'lab', 'agent', 'shop', 'other']),
  name: z.string().min(1, 'Name is required'),
  contactPerson: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().email('Invalid email').optional().or(z.literal('')),
  address: z.string().optional(),
  taxId: z.string().optional(),
  active: z.boolean().default(true),
});

export type RefPartnerFormData = z.infer<typeof partnerSchema>;
